import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { registerPwaSW } from "@theg1group/pwa-kit";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initErrorReporter } from "./lib/error-reporter";
import "./index.css";

initErrorReporter();

// Install the PWA service worker (offline shell + push). No-ops in dev.
registerPwaSW();

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5,
			retry: 1,
		},
	},
});

const root = document.getElementById("root");

if (!root) {
	throw new Error("Root element not found");
}

createRoot(root).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<App />
		</QueryClientProvider>
	</StrictMode>,
);
